/**
 * CCMS SDK configuration for the Procedures portal.
 *
 *   browser → SDK fetch → Express proxy on :5185 → microservices
 *                         (or production via BACKEND_BASE_URL)
 *
 * The SDK's `baseUrl` points at the Express proxy (same pattern as ccms_v2, the Resource Centre and
 * Carpool). In production the Docker build sets it to `/api` and the SPA's nginx forwards /api/* to the
 * proxy container (procedures-proxy-server:5185).
 */
export const CCMS_BASE_URL =
  import.meta.env.VITE_CCMS_BASE_URL
    ? import.meta.env.VITE_CCMS_BASE_URL
    : '/api';

/** Gateway prefix of the Procedures Management API (port 5047). */
export const CCMS_SERVICE_PATH_PROCEDURES =
  import.meta.env.VITE_CCMS_SERVICE_PATH_PROCEDURES || 'procedures';

/** Public origin of this portal (the QR codes point at {origin}/p/{code}). */
export const PROCEDURES_PUBLIC_ORIGIN =
  import.meta.env.VITE_PROCEDURES_PUBLIC_ORIGIN || (typeof window !== 'undefined' ? window.location.origin : '');
